<script setup lang="ts">
import type { HTMLAttributes } from 'vue'

const props = withDefaults(
  defineProps<{
    class?: HTMLAttributes['class']
    serviceName?: string
    company?: string
    icon: string
    iconClass?: string
    iconSize?: string
  }>(),
  {
    class: undefined,
    serviceName: undefined,
    company: 'Courier',
    iconSize: '44px',
    iconClass: undefined
  }
)
</script>

<template>
  <div :class="cn('flex gap-3 items-center', props.class)">
    <Icon
      :name="icon"
      :alt="serviceName"
      :size="iconSize"
      :class="cn(props.iconClass, 'dark:text-inherit')"
      class="border bg-white dark:bg-surface-container-highest border-outline-variant rounded-lg object-contain"
    />
    <div v-if="props.serviceName" class="flex flex-col">
      <span class="text-lg font-semibold">{{ serviceName }}</span>
      <span class="text-sm text-on-surface-variant">{{ company }}</span>
    </div>
  </div>
</template>
